import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { Card, Typography } from 'antd'
import { CheckCircleOutlined, StarOutlined } from '@ant-design/icons'

const { Title, Paragraph } = Typography

export const ReviewThankYou: React.FC = () => {
  const { token } = useParams()
  const [searchParams] = useSearchParams()
  const businessName = searchParams.get('business') || 'us'
  const sentiment = searchParams.get('sentiment') || 'positive'

  return (
    <div style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '24px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ maxWidth: 450, width: '100%' }}>
        <Card 
          style={{ 
            borderRadius: 16, 
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
            textAlign: 'center'
          }}
        >
          <div style={{ padding: '30px 0' }}>
            <CheckCircleOutlined 
              style={{ 
                fontSize: 64, 
                color: sentiment === 'positive' ? '#52c41a' : '#1890ff', 
                marginBottom: 16 
              }} 
            />
            
            <Title level={3} style={{ marginBottom: 8 }}>
              Thank You for Your Feedback!
            </Title>
            
            {sentiment === 'positive' ? (
              <>
                <Paragraph style={{ fontSize: 16, color: '#666' }}>
                  We're thrilled you had a great experience!
                </Paragraph>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  gap: 4,
                  marginTop: 16
                }}>
                  {[1, 2, 3, 4, 5].map(i => (
                    <StarOutlined 
                      key={i} 
                      style={{ fontSize: 24, color: '#faad14' }} 
                    />
                  ))}
                </div>
              </>
            ) : (
              <Paragraph style={{ fontSize: 16, color: '#666' }}>
                We appreciate you taking the time to share your experience.
                Your feedback helps us improve our service.
              </Paragraph>
            )}
            
            <Paragraph style={{ color: '#888', marginTop: 24 }}>
              Thank you for choosing <strong>{businessName}</strong>.
            </Paragraph>
          </div>
        </Card>

        {/* Footer */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: 24,
          color: 'rgba(255,255,255,0.8)',
          fontSize: 12
        }}>
          Powered by {businessName}
        </div>
      </div>
    </div>
  )
}
